import React from "react";
import "./ToggleIcon.css";
import images from "../../../../../../utilities/images/images";

const ToggleIcon = (props) => {
  const { isOpen } = props;
  return (
    <img
      src={isOpen ? images.BottomClose : images.BottomOpen}
      alt={isOpen ? "Close" : "Open"}
      className="toggle-icon"
    />
  );
};

export default ToggleIcon;
